import {getFrontType, validateSettings} from '@/config/helpers';
import type {ISettings} from '@/config/types';

import {ESettingsFrontType} from '@/config/enums';

export const settings: ISettings = {
  APP: {
    VERSION: __APP_VERSION__ ?? 'unknown',
    NAME: __APP_NAME__ ?? 'unknown',
    TEST: import.meta.env.TEST === 'true',
  },
  SERVICES: {
    KEYCLOAK: {
      URL: import.meta.env.VITE_KEYCLOAK_URL ?? 'https://keycloak.sw.kbsynergya.ru',
      REALM:
        import.meta.env.VITE_KEYCLOAK_REALM ?? 'dev',
      CLIENT_ID:
        import.meta.env.VITE_KEYCLOAK_CLIENT_ID ??
        'tetis_frontend',
      CLIENT_ID_ROLES:
        import.meta.env.VITE_KEYCLOAK_CLIENT_ID_ROLES ??
        'tetis_backend',
    },

    FRONT: {
      TYPE: getFrontType(),
      IS_ADMIN: getFrontType() === ESettingsFrontType.ADMIN,
      IS_CLIENT: getFrontType() === ESettingsFrontType.CLIENT,
      hasAccessByMode: (modes?: ESettingsFrontType[]) =>
        (modes ?? []).includes(getFrontType()),
      THEME: {},
    },

    BASE: {URL: import.meta.env.VITE_BACKEND_URL ?? 'https://dev-tetis-backend.sw.kbsynergya.ru/api/v1'},

    WORKER: {
      IFRAME_URL:
        import.meta.env.VITE_WORKER_IFRAME_URL ??
        '',
    },
  },
};

settings.SERVICES.FRONT.THEME = {};

if (Object.keys(settings.SERVICES.FRONT.THEME).length === 0) {
  settings.SERVICES.FRONT.THEME = {
    // colorPrimary: '#9d0000',
    colorPrimary: '#a30a0a',
    colorPrimaryBg: '#f6efef',

    colorError: '#ff0100',
  };
}

validateSettings(settings);

export default settings;
